import { Component } from '@angular/core';



@Component({
    selector: 'app-hero-section',
    standalone: true,
    templateUrl: './hero-section.component.html',
    styleUrl: './hero-section.component.scss',
    imports: []
})
export class HeroSectionComponent {
}
